/******************/
/* Google Maps helpers */
/******************/

var $ = require('jquery');
var _ = require('underscore');

var JSContext = require('./jscontext');


var DEFAULT_ZOOM_LEVEL = 15;


var googleGeocodeAddress = function(address, callback) {
    if(typeof google !== 'object' || typeof google.maps !== 'object') {
        callback(false, "Unable to load Google API script.");
    }
    var geocoder = new google.maps.Geocoder();
    var string = address;
    if (_.isObject(address)) {
        string = _.chain(["street", "suite", "city", "state", "country", "zip_code"])
            .map(_.propertyOf(address))
            .compact()
            .join(" ")
            .value();
    }
    geocoder.geocode({address: string}, function(result, status) {
        if (status === google.maps.GeocoderStatus.OK) {
            var latlng = result[0].geometry.location;
            callback([latlng.lat(), latlng.lng()]);
        } else {
            callback(false, status);
        }
    });
};

var _googleMaps = {};

var showGoogleMap = function(latlng, containerID, useDefaultMarker, options) {
    if(typeof google === 'object' && typeof google.maps === 'object') {
        latlng = latlng || [];
        useDefaultMarker = useDefaultMarker === undefined ? true : useDefaultMarker;
        var defaults = {
            zoom: DEFAULT_ZOOM_LEVEL,
            mapTypeControl: false,
            scrollwheel: false,
            disableDefaultUI: false,
            disableDoubleClickZoom: false,
            draggable: true
        };
        options = _.extend(defaults, options);
        // Set center, defaulting to empty gmaps LatLng object.
        options.center = latlng.length ?
            {lat: latlng[0], lng: latlng[1]} : new google.maps.LatLng();

        // Only have one map per container.
        var map = _googleMaps[containerID];
        if (!map) {
            map = new google.maps.Map(document.getElementById(containerID), options);
            _googleMaps[containerID] = map;
        } else {
            // Force a resize so that we don't see missing tiles
            google.maps.event.trigger(map, "resize");
        }
        map.setOptions(options);

        // Don't show default marker if we don't have a latlng to place it at.
        if (useDefaultMarker && latlng) {
            new google.maps.Marker({
                position: options.center,
                map: map
            });
        }
        return map;
    }
};

// Create a fake static map by using the GMaps JS API and stripping
// the map of all controls (see comment below for reasoning).
var showStaticGoogleMap = function(latlng, containerID) {
    return showGoogleMap(latlng, containerID, true, {
        disableDefaultUI: true,
        disableDoubleClickZoom: true,
        draggable: false
    });
};

// NOTE: This currently only works in dev. To work in prod, we have to
// somehow sign each url server-side, which is yet to be implemented.
// For now, use the alternative showStaticGoogleMap, which fakes a static
// map by stripping a dynamic map of all controls.
var _showStaticGoogleMap = function(latlng, containerID) { // eslint-disable-line no-unused-vars
    var $container = $("#" + containerID);
    var center = latlng.join(",");

    var params = {
        "center": center,
        "zoom": DEFAULT_ZOOM_LEVEL,
        "size": $container.width() + "x" + $container.height(),
        "markers": center,
        "key": JSContext.getGoogleMapsKey()
    };

    var staticMapUrl = "url('https://maps.googleapis.com/maps/api/staticmap?" +
        $.param(params) + "')";

    var styles = {
        "background-size": "cover",
        "background-position": "center",
        "background-image": staticMapUrl
    };
    $container.css(styles);
};

var addMarkerToMap = function(markerOptions) {
    if(typeof google === 'object' && typeof google.maps === 'object') {
        return new google.maps.Marker(markerOptions);
    }
};

exports.googleGeocodeAddress = googleGeocodeAddress;
exports.showGoogleMap = showGoogleMap;
exports.showStaticGoogleMap = showStaticGoogleMap;
exports.addMarkerToMap = addMarkerToMap;



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/Lib1ThemeBuild/Platforms/1804Build/~/poly-js-utils/src/map-tools.js
// module id = 324
// module chunks = 8